module.exports = __webpack_public_path__ + "static/media/Template.fe7f2375.zip";